import React from "react";
import { Phone, WhatsappLogo, MapPin, Globe, Clock, Envelope } from "@phosphor-icons/react";
import { COMPANY } from "@/data/site";
import LeadForm from "@/components/LeadForm";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <section className="bg-white py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="label-eyebrow">Contact</div>
          <h1 className="mt-4 font-heading font-black text-5xl md:text-7xl tracking-tighter text-slate-950 max-w-4xl">
            Let's build your <span className="italic font-light">smart future.</span>
          </h1>
          <p className="mt-6 max-w-xl text-lg text-slate-600">Free site survey within 48 hours across all 38 districts of Tamil Nadu.</p>
        </div>
      </section>

      <section className="bg-slate-50 py-20">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5 space-y-8">
            <div>
              <div className="label-eyebrow">Office</div>
              <h3 className="mt-3 font-heading font-bold text-2xl text-slate-950">{COMPANY.name}</h3>
              <div className="mt-5 space-y-4 text-sm text-slate-700">
                <div className="flex gap-3"><MapPin size={20} weight="duotone" className="shrink-0 text-amber-500" />
                  <div>{COMPANY.address.line1}<br/>{COMPANY.address.line2}<br/>{COMPANY.address.city} – {COMPANY.address.pincode}<br/>{COMPANY.address.state}</div>
                </div>
                <a href={`tel:${COMPANY.phone}`} className="flex gap-3 items-center hover:text-slate-950 font-semibold" data-testid="contact-phone">
                  <Phone size={20} weight="duotone" className="text-emerald-500" /> {COMPANY.phoneDisplay}
                </a>
                <a href={`https://wa.me/${COMPANY.whatsapp}`} target="_blank" rel="noopener noreferrer" className="flex gap-3 items-center hover:text-slate-950 font-semibold" data-testid="contact-whatsapp">
                  <WhatsappLogo size={20} weight="duotone" className="text-emerald-500" /> WhatsApp Chat
                </a>
                <div className="flex gap-3 items-center"><Globe size={20} weight="duotone" className="text-blue-500" /> {COMPANY.website}</div>
                <div className="flex gap-3 items-center"><Envelope size={20} weight="duotone" className="text-slate-700" /> {COMPANY.email}</div>
                <div className="flex gap-3 items-center"><Clock size={20} weight="duotone" className="text-amber-500" /> Mon-Sat 9:00 AM – 7:00 PM</div>
              </div>
            </div>

            <div className="card-flat overflow-hidden">
              <iframe
                title="TamilBTC Location"
                src="https://maps.google.com/maps?q=Tamil+BTC,+Uthani+Main+Road,+Uthani+village,+Papanasam,+Tamil+Nadu+614208&output=embed"
                width="100%" height="280" style={{ border: 0 }} allowFullScreen=""
                loading="lazy" referrerPolicy="no-referrer-when-downgrade"
                data-testid="contact-map"
              />
              <a
                href="https://share.google/l51PUCIvhtFwuX5GU"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-between gap-2 bg-slate-950 hover:bg-slate-800 text-white px-5 py-3 text-sm font-semibold transition-colors"
                data-testid="contact-directions-link"
              >
                <span className="inline-flex items-center gap-2"><MapPin size={16} weight="bold" /> Get Directions</span>
                <span className="text-xs uppercase tracking-wider opacity-80">Open in Maps →</span>
              </a>
            </div>
          </div>

          <div className="md:col-span-7">
            <LeadForm source="contact" />
          </div>
        </div>
      </section>
    </div>
  );
}
